import { useNavigate } from "react-router-dom";
import { InteractiveBlock } from "../InteractiveBlock";
import classNames from "classnames";
import {
  AvisDirection,
  IAvisIconItem,
  INavigationLink,
} from "../../../../../models";

interface IAvisNavigationItemProps {
  navLink: INavigationLink;
  className?: string;
  icon?: IAvisIconItem;
}
export function AvisNavigationItem(props: Readonly<IAvisNavigationItemProps>) {
  const { navLink, className, icon } = props;
  const navigate = useNavigate();

  const { title, url, onClick, rewrite } = navLink ?? {};
  const handleClick = () => {
    if (onClick?.()) return;

    if (url) {
      navigate(url, { replace: rewrite });
    }
  };
  const iconPaddingClass =
    icon?.location === AvisDirection.Left ? "pr-1" : "pl-1";
  const iconClassNames = classNames(
    "fas",
    icon?.className,
    iconPaddingClass,
    "navigation-item-icon",
  );
  const blockClassName = classNames("avis-navigation-link", className);
  return (
    <div className="avis-navigation-link-wrapper">
      <InteractiveBlock className={blockClassName} asLink onClick={handleClick}>
        {icon?.location === AvisDirection.Left && (
          <i className={iconClassNames} />
        )}
        {title}
        {icon?.location === AvisDirection.Right && (
          <i className={iconClassNames} />
        )}
      </InteractiveBlock>
    </div>
  );
}
